import apiClient from '../client';

export const streakService = {
  getCurrentStreak: async () => {
    const response = await apiClient.get('/api/v1/streaks/current');
    return response.data;
  },

  getStreakHistory: async () => {
    const response = await apiClient.get('/api/v1/streaks/history');
    return response.data;
  },

  updateStreak: async () => {
    const response = await apiClient.post('/api/v1/streaks/update');
    return response.data;
  }
};